<script>
import { PortalTarget } from 'portal-vue';
import { scrollToElement, contentTop } from '~/lib/utils/common_utils';
import VulnerabilityCounts from './vulnerability_counts.vue';
import VulnerabilityListGraphql from './vulnerability_list_graphql.vue';
import VulnerabilityFilters from './vulnerability_filters.vue';
import { FILTERS } from './constants';

export default {
  components: {
    VulnerabilityCounts,
    VulnerabilityListGraphql,
    VulnerabilityFilters,
    PortalTarget,
  },
  props: {
    filterDropdowns: {
      type: Array,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
    filterFn: {
      type: Function,
      required: false,
      default: (filters) => filters,
    },
    // Whether this report is visible on the page or not. Intended to be used with tabs so that if
    // the tab that the report is in is not active, the vulnerabilities aren't fetched.
    isVisible: {
      type: Boolean,
      required: false,
      default: true,
    },
    showCounts: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      graphqlFilters: undefined,
    };
  },
  computed: {
    shouldShowProjectNamespace() {
      return this.filterDropdowns.includes(FILTERS.PROJECT);
    },
  },
  methods: {
    updateGraphqlFilters(graphqlFilters) {
      this.graphqlFilters = this.filterFn(graphqlFilters);
    },
    emitCountsChanged(counts) {
      this.$emit('counts-changed', counts);
    },
    scrollToTopOfList() {
      const { vulnerabilityListTop } = this.$refs;
      // Only scroll to the top of the vulnerability list if it's above and outside the main content
      // area (the space below the static page header).
      if (vulnerabilityListTop.getBoundingClientRect().top < contentTop()) {
        scrollToElement(vulnerabilityListTop);
      }
    },
  },
  portalName: 'vulnerability-report-sticky',
};
</script>

<template>
  <div>
    <vulnerability-counts
      v-if="showCounts"
      class="gl-mb-7"
      :filters="graphqlFilters"
      @counts-changed="emitCountsChanged"
    />

    <div ref="vulnerabilityListTop" data-testid="vulnerability-list-top"></div>

    <div class="security-dashboard-filters">
      <vulnerability-filters :filters="filterDropdowns" @filters-changed="updateGraphqlFilters" />
      <portal-target v-if="isVisible" :name="$options.portalName" />
    </div>

    <vulnerability-list-graphql
      v-if="isVisible"
      :fields="fields"
      :filters="graphqlFilters"
      :show-project-namespace="shouldShowProjectNamespace"
      :portal-name="$options.portalName"
      @vulnerability-clicked="$emit('vulnerability-clicked', $event)"
      @query-variables-changed="scrollToTopOfList"
    />
  </div>
</template>
